import Dialog from '@mui/material/Dialog';
import { Box, Button, DialogContent, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './StyleBoard.scss';
import { useDeleteImage } from '../../api/styleBoard';
import { UploadResponseItem } from '../../models/cloudinary.models';

interface DescriptionModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  image: UploadResponseItem;
  ResetSelectedImage: () => void;
  setShowError: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DeleteImageModal = (props: DescriptionModalProps) => {
  const { open, setOpen, image, ResetSelectedImage, setShowError } = props;
  const deleteMutation = useDeleteImage();

  const handleError = () => {
    setOpen(false);
    setShowError(true);
    ResetSelectedImage();
  };

  return (
    <>
      <Dialog
        data-testid="delete-image-modal"
        className="delete-image-modal"
        open={open}
        onClose={() => {
          setOpen(false);
          ResetSelectedImage();
        }}
        aria-labelledby="auth-dialog-title"
      >
        <Box className="container">
          <Button
            variant="transparent"
            className="close-btn"
            onClick={() => {
              setOpen(false);
              ResetSelectedImage();
            }}
            sx={{ color: 'white' }}
          >
            <CloseIcon sx={{ fill: '#49454F' }} />
          </Button>
          <DialogContent className="content">
            <Typography variant="h2" className="description-title">
              Delete Image?
            </Typography>
            <Button
              className="save-btn"
              disabled={deleteMutation.isPending}
              onClick={() =>
                deleteMutation.mutate(image.public_id || '', {
                  onSuccess: () => {
                    setOpen(false);
                    ResetSelectedImage();
                  },
                  onError: () => handleError(),
                })
              }
              variant="contained"
            >
              {deleteMutation.isPending ? 'Deleteing...' : 'Delete'}
            </Button>
            <Button
              className="save-btn"
              onClick={() => {
                setOpen(false);
                ResetSelectedImage();
              }}
            >
              Cancel
            </Button>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};
